interface SuccessCardProps {
  onSendAnother: () => void;
}

const SuccessCard = ({ onSendAnother }: SuccessCardProps) => (
  <>
    <div className="success-box" onClick={onSendAnother}>
      <p className="success-box-text">תגובתך נשלחה בהצלחה ונשמרה במערכת!</p>
    </div>
    <button
      type="button"
      className="success-reset-button"
      onClick={onSendAnother}
    >
      תגובה נוספת
    </button>
  </>
);

export default SuccessCard;
